import { render, staticRenderFns } from "./singleSignOn.vue?vue&type=template&id=4b7b22a4&"
import script from "./singleSignOn.vue?vue&type=script&lang=ts&"
export * from "./singleSignOn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports